__webpack_require__.p = "/energydrink/v1/resources/_next/";